import { Link } from "@mui/material";

export default function ActionItem(props) {
  return (
    <Link
      color="secondary.main"
      href={"#"}
      onClick={props.onClick}
      sx={{
        textDecoration: "none",
        "&:hover": {
          fontWeight: "600",
        },
      }}
    >
      {props.label}
    </Link>
  );
}
